import React from 'react';
import "./Footer.css";

const Footer = () => {
  return (
    <footer>
        <div className="footer-container">
            <div className="footer-flex">
                <h3>ID 2025 danyal lotfi All Rights Reserved.</h3>
            </div>
        </div>
    </footer>
  )
}

export default Footer